import React from "react";
import "./ContactUs.css";
//-----------------------------------------
import contactUsPhoto from "../images/contactUsPhoto.png";
//-----------------------------------------

function ContactUs() {
  return (
    <div className="contactUs_container">
      <div className="contactUs_bangla">
        আপনার ব্যবসায়িক প্রতিষ্ঠানের জন্য বিশেষ Web-App তৈরী এবং E-Shop পরিষেবা
        ব্যবহার করতে আমাদের সাথে E-Mail 'এর মাধ্যমে যোগাযোগ করুন। আপনার
        প্রতিষ্টানের নাম, ঠিকানা, ফোন নম্বর এবং কোন প্রকার ব্যবসার জন্য আপনি
        E-Shop পরিষেবা ব্যবহার করতে চান জানিয়ে E-Mail পাঠালে আমরা অবশ্যই আপনার
        ফোন নম্বরে যোগাযোগ করবো।
      </div>

      <div className="contactUs_photo_div">
        <div className="email_address">
          paranaeshopservices
          <br />
          @gmail.com
        </div>
        <img
          className="contactUs_photo"
          src={contactUsPhoto}
          alt="contactUs Logo"
        />
      </div>
      <div className="contactUs_english">
        Please contact us to create Web-App and use E-shop services for your
        business . Please Send E-mail to us with name, address, phone number and
        mention what type of business it is, we will contact you over phone.
      </div>
    </div>
  );
}

export default ContactUs;
